export function parserFromDto(zodDto) {
    return (json) => zodDto.create(json);
}
export function arrayParserFromDto(zodDto) {
    return (json) => {
        if (!Array.isArray(json)) {
            throw new Error('Array expected');
        }
        return json.map((item) => zodDto.create(item));
    };
}
